module.exports = __webpack_public_path__ + "static/media/card-ai-agent-mobile-es.7de3676a.png";